import { render, staticRenderFns } from "./orderTab.vue?vue&type=template&id=6f7fe17a&scoped=true&"
import script from "./orderTab.vue?vue&type=script&lang=js&"
export * from "./orderTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7fe17a",
  null
  
)

export default component.exports